/**
 * Replaces mention tokens in a plain-text comment/note body with the mentioned
 * user's display name, e.g. `@[user:<id>]` -> `@Alice Agent`.
 *
 * Rich surfaces (the full timeline) use the `MentionText` component to render
 * mentions as styled pills. Preview/plain-text surfaces (recent-activity card,
 * activity feed, stream history) cannot render React pills inside a truncated
 * snippet, so they resolve tokens to plain `@Name` text via this helper. When a
 * mentioned user is missing from the map we fall back to the raw id rather than
 * leaving the literal `@[user:...]` token visible.
 */

// Matches both @[user:<id>] (canonical) and @[<id>] (legacy). Kept in sync with
// MENTION_DISPLAY_RE in MentionText.tsx.
const MENTION_TOKEN_RE = /@\[(?:user:)?([^\]]+)\]/g;

export function resolveMentions(body: string, mentionedUsers: Record<string, string>): string {
	return body.replace(MENTION_TOKEN_RE, (_match, id: string) => `@${mentionedUsers[id] ?? id}`);
}
